<template>
    <div id="page-send-mail" class="p-6" v-if="tabActive == 1">
        <!-- button mail-->
        <div class="pt-6 mb-4 container-wrap">
            <div class="flex flex-wrap items-end justify-end ag-row-position-relative">
                <!----Send mode------>
                <div class="d-flex btn-groups">
                    <vs-button color="white" class="tab-send-mail" :class="tabActive == 1 ? 'tab-active' : ''"
                               @click="setTab(1)"><span :class="tabActive == 2 ? 'text-not-active' : ''">送信</span>
                    </vs-button>
                    <vs-button color="white" class="tab-history" :class="tabActive == 2 ? 'tab-active' : ''"
                               @click="setTab(2)"><span :class="tabActive == 1 ? 'text-not-active' : ''">履歴</span>
                    </vs-button>
                </div>
                <!-- <vs-button v-if="isRead" color="primary" class="mx-2" @click="onSaveDraftDuplicate">返信メール作成
                </vs-button> -->
                <vs-button v-if="isSetPreviousMail" color="primary" class="mx-2" @click="setPreMailDraft">クリア
                </vs-button>
                <vs-button
                        v-if="this.tabActive === 1"
                        :disabled="sendMailButtonDisable || isPreventDoubleClick"
                        @click="beforeSendMail" color="success" icon="send">送信
                </vs-button>
                <vs-button v-if='!isEmbedded' color="#d9d9d9" icon="cancel" @click="onBack">戻る</vs-button>
            </div>
        </div>

        <div v-if="tabActive == 1">
            <!-- dialog confirm send: no subject, content -->

            <!-- email from.to -->
            <div class="mail-from-to">
                <vs-row class="flex-wrap items-center justify-start row-email">
                    <vs-col vs-w="1">
                        <span class="pl-2">返信No</span>
                    </vs-col>
                    <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                        <input v-model="countReplyMail" disabled class="w-full pl-2 background_color__white"/>
                    </vs-col>
                </vs-row>
                <vs-row class="flex-wrap items-center justify-start row-email" v-if="isRead && sentDateTime">
                    <vs-col vs-w="1">
                        <span class="pl-2">送信日時</span>
                    </vs-col>
                    <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                        <input v-model="sentDateTime" disabled class="w-full pl-2 background_color__white"/>
                    </vs-col>
                </vs-row>
                <vs-row class="flex-wrap items-center justify-star row-email">
                    <vs-col vs-w="1">
                        <span class="block leading-none pl-2">方法</span>
                    </vs-col>
                    <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                        <v-select class="w-full" v-if="isReport"
                                  id="inquiryType"
                                  v-model="inquiryType"
                                  :options="listInquiryTypeSelect"
                                  :searchable="false">
                            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
                        </v-select>
                        <input v-else v-model="inquiryType.label" disabled class="w-full pl-2 background_color__white"/>
                    </vs-col>
                </vs-row>
                <vs-row class="flex-wrap items-center justify-star row-email">
                    <vs-col vs-w="1">
                        <span class="block leading-none pl-2">種別</span>
                    </vs-col>
                    <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                        <v-select class="w-full" v-if="isReport"
                                  id="type"
                                  v-model="type"
                                  :options="listTypeSelect"
                                  :searchable="false">
                            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
                        </v-select>
                        <input v-else v-model="type.label" disabled class="w-full pl-2 background_color__white"/>
                    </vs-col>
                </vs-row>
                <vs-row class="flex-wrap items-center justify-star row-email">
                    <vs-col vs-w="1">
                        <span class="block leading-none pl-2">担当者</span>
                    </vs-col>
                    <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                        <v-select class="w-full" v-if="isReport"
                                  id="mst_user"
                                  v-model="mst_user"
                                  :options="listMstUserSelect"
                                  :searchable="false">
                            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
                        </v-select>
                        <input v-else v-model="mst_user.label" disabled class="w-full pl-2 background_color__white"/>
                    </vs-col>
                </vs-row>
                <vs-row class="flex-wrap items-center justify-star row-email">
                    <vs-col vs-w="1">
                        <span class="pl-2">From</span>
                    </vs-col>
                    <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
                        <input v-if="!isReport" v-model="mailFrom" class="w-full pl-2" readonly/>
                        <v-select class="w-full"
                                  v-else
                                  id="from"
                                  v-model="mailFrom"
                                  :options="listMailFrom"
                                  :searchable="false">
                            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
                        </v-select>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-offset="1" vs-w="11">
                        <span class="error-form">{{ errors.first('mailCC') | convertError }}</span>
                    </vs-col>
                </vs-row>
                <vs-row class="flex-wrap items-center justify-start row-email">
                    <vs-col vs-w="1">
                        <span class="pl-2">CC</span>
                    </vs-col>
                    <vs-col id="tags-cc" vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail" style="position: relative;">
                        <vs-chips :class="{'pointer-events-none': isRead}" v-model="listMailCC" class="w-full vschipsContacts" ref="vsChipCc" id="vschipCcs">
                            <vs-chip v-for="(cc, index) in listMailCC" :key=cc+index :id="'tag-cc-'+ index"
                                     :closable="!isRead" :color="validateEmail(cc)?'dark':'danger'" transparent
                                     @click="listMailCC.splice(index,1)">
                                {{ cc | convertEmail }}
                            </vs-chip>
                        </vs-chips>
                        <!-- <input type="text" v-model="mailCC" name="mailCC"  @keyup.enter="handleInputEmailCC()"/> -->
                        <ul class="w-full rounded-b-lg" id="contacts_dropdown_CC" style="z-index: 100000; position: absolute !important; background-color: #FFFFFF; top: 38px; border-bottom: 3px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; padding-bottom: 5px;">
                            <li v-for="(to, index) in listContactComputed" @click="contactSelected(to.mail_address,'CC')" class="cursor-pointer contact-li">{{ to.mail_address }}</li>
                        </ul>
                        <feather-icon v-show="showIconContacts" icon="BookOpenIcon" class="cursor-pointer z-100" @click="showListContact('CC')" style="position: absolute !important; right: 17px;"/>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-offset="1" vs-w="11">
                        <span class="error-form">{{ errors.first('mailBCC') | convertError }}</span>
                    </vs-col>
                </vs-row>
                <vs-row class="flex-wrap items-center justify-start row-email">
                    <vs-col vs-w="1">
                        <span class="pl-2">BCC</span>
                    </vs-col>
                    <vs-col id="tags-bcc" vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail" style="position: relative;">
                        <vs-chips :class="{'pointer-events-none': isRead}" v-model="listMailBCC" class="w-full vschipsContacts"  ref="vsChipBcc" id="vschipBccs">
                            <vs-chip v-for="(bcc, index) in listMailBCC" :key=bcc+index :id="'tag-bcc-'+ index"
                                     :closable="!isRead" :color="validateEmail(bcc)?'dark':'danger'" transparent
                                     @click="listMailBCC.splice(index,1)">
                                {{ bcc | convertEmail }}
                            </vs-chip>
                        </vs-chips>
                        <!-- <input type="text" v-model="mailBCC" name="mailBCC"  @keyup.enter="handleInputEmailBCC()"/> -->
                        <ul class="w-full rounded-b-lg" id="contacts_dropdown_BCC" style="z-index: 100000; position: absolute !important; background-color: #FFFFFF; top: 38px; border-bottom: 3px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; padding-bottom: 5px;">
                            <li v-for="(to, index) in listContactComputed" @click="contactSelected(to.mail_address,'BCC')" class="cursor-pointer contact-li">{{ to.mail_address }}</li>
                        </ul>
                        <feather-icon v-show="showIconContacts" icon="BookOpenIcon" class="cursor-pointer z-100" @click="showListContact('BCC')" style="position: absolute !important; right: 17px;"/>
                    </vs-col>
                </vs-row>
            </div>

            <!-- CSV file -->
            <div class="mt-10 card-file-input">
                <vs-row class="flex-wrap justify-start items-center row-card-file">
                    <vs-col vs-w="1.75" class="card-title">
                        <span class="pl-2">CSVファイルの内容</span>
                    </vs-col>
                    <vs-col vs-w="2.5" class="flex flex-wrap items-center justify-start input-tag-file">
                        <div class="pl-2">
                            <input type="file" ref="csv_file" accept=".csv" @click="$refs.csv_file.value=''"
                                   v-on:change="handleCSVFile" style="display: none"/>
                            <vs-button :disabled="isRead" color='darkgray' @click="$refs.csv_file.click()">CSVファイル選択
                            </vs-button>
                        </div>
                    </vs-col>
                    <vs-col vs-w="6.75">
                        <div v-if="csv_file" style="display: inline-block">
                            <vs-chip class="mt-1 mr-1" color="dark" transparent closable @click="removeCSVFile">
                                {{ this.csv_file }}
                            </vs-chip>
                        </div>
                    </vs-col>
                </vs-row>
                <div class="card-subject csv-content">
                    <div class="w-full div-subject" v-if="!csv_data">CSVファイルがありません。</div>
                    <div class="w-full" v-else>
                        <vs-table :class="csv_header.length == 1 ? 'table-add-one-colum':''" stripe noDataText='' :data="csv_raw">
                            <template>
                                <vs-th v-for="(header,index) in csv_header" :key="header+index"> {{ header }}</vs-th>
                            </template>
                            <template>
                                <vs-tr v-for="(row,row_idx) in csv_raw" :key="row+row_idx">
                                    <vs-td v-for="(value, value_idx) in row" :key="value+value_idx">
                                        {{ value }}
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>

            <!-- file -->

            <!-- body, subject -->
            <div class="pt-10 card-subject">
                <div class="flex-wrap items-center justify-start card-title">
                    <span class="pl-2">件名</span>
                </div>
                <div>
                    <!--          <vs-input v-if="!isRead" v-model="mailSubject" maxlength="512" class="w-full"/>-->
                    <vs-textarea v-if="!isRead" v-model="mailSubject"></vs-textarea>
                    <div v-else class="w-full div-subject" v-html="mailSubject"></div>
                </div>
                <div class="card-title">
                    <span class="pl-2">メール本文</span>

                    <vs-col vs-w="10.25" class="pl-2 flex flex-wrap items-center justify-start flex-row">
                        <!----Dropdown mail template list---->
                        <vs-dropdown vs-custom-content vs-trigger-click :disabled="isRead">
                            <div class="pl-2">
                                <vs-button :disabled="isRead" color="darkgray">テンプレート一覧</vs-button>
                            </div>
                            <vs-dropdown-menu class="mail-template-list-dropdown">
                                <h5>テンプレート</h5>
                                <vs-divider/>
                                <div class="mail-template-list">
                                    <div class="template-item" v-for="template in listMailTemplate" :key="template.id">
                                        <vs-dropdown-item @click="displayTemplate(template.id)">
                                            <span>{{ template.template_name }}</span>
                                        </vs-dropdown-item>
                                        <vs-icon icon="close" @click="deleteTemplate(template.id)"></vs-icon>
                                    </div>
                                </div>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                        <!---------Save template-------->
                        <div class="pl-2">
                            <vs-button :disabled="isRead" color="darkgray" @click="popupAdd=true">テンプレート保存</vs-button>
                            <vs-popup id="dialogDelete" title="テンプレートの新規作成" :active.sync="popupAdd">
                                <div>
                                    <p class='my-2'>テンプレート名</p>
                                    <vs-input label-placeholder="新規" v-model="templateName"/>
                                </div>
                                <div class="flex justify-end mt-4">
                                    <vs-button @click="hidePopupAddMail()" icon="cancel" color="lightgrey" class="mx-2">
                                        キャンセル
                                    </vs-button>
                                    <vs-button icon="save" color="primary" @click="addTemplate()">テンプレートとして保存
                                    </vs-button>
                                </div>
                            </vs-popup>
                        </div>
                        <div class="pl-2">
                            <vs-button :disabled="isRead" color="darkgray" @click="popUpSignature = true">署名ボタン
                            </vs-button>
                            <vs-popup title="署名一覧" :active.sync="popUpSignature">
                                <div>
                                    <ag-grid-vue
                                            id="myGridSignature"
                                            :gridOptions="gridOptionsSignature"
                                            class="ag-theme-material w-100 my-4 ag-grid-table database"
                                            :columnDefs="columnDefsSignature"
                                            :defaultColDef="defaultColDef"
                                            :rowData="listUserSignatureComputed"
                                            rowSelection="single"
                                            colResizeDefault="shift"
                                            :animateRows="true"
                                            :pagination="false"
                                            :domLayout="domLayout"
                                            @grid-ready="onGridReadySignature"
                                            @selection-changed="onSelectionChangedSignature"
                                            :suppressPaginationPanel="true"
                                            :overlayNoRowsTemplate="noRowsTemplate"
                                            :detailRowAutoHeight="true"
                                    ></ag-grid-vue>
                                </div>
                                <div class="flex justify-end">
                                    <vs-button :disabled="!signatureSelect && signatureSelect != ''"
                                               @click="applySignature" color="success"
                                               style="padding: 8px; margin-right: 5px;height: 37px">テキストを挿入
                                    </vs-button>
                                    <vs-button @click="popUpSignature = false" color="lightgrey" icon="cancel"
                                               style="padding: 8px; margin-right: 5px;height: 37px">閉じる
                                    </vs-button>
                                </div>
                            </vs-popup>
                        </div>
                    </vs-col>
                </div>
                <div class="div-show-receive-mail">
                    <quill-editor id="quillMessage" ref="quillMessage" v-if="modeHTML" :disabled="isRead" :class="{'pointer-events-none': isRead}"  v-model="mailMessage" :options="editorOption"/>
                </div>
            </div>
            <!-- dialog confirm changeMode HTML-->
        </div>
        <!--                    pagination-->

         <!-- dialog contact list -->
        <Contacts
            :activeModelContacts="activeModelContacts"
            :typeModalContact="typeModalContact"
        >
        </Contacts>


        <vs-popup id="dialogSend" :title="titleDialog" :active.sync="activeSend" button-close-hidden v-if="showDialogSend">
            <div>
          <span>
            {{ confirmQuestion }}
          </span>
            </div>
            <div class="flex justify-end mt-4">
                <vs-button @click="confirm" icon="check" color="success" class="mx-2" :disabled="isPreventDoubleClick">はい</vs-button>
                <vs-button @click="activeSend = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
            </div>
        </vs-popup>
        <vs-popup ref="dialogConfirm" title="テキストモードに切り替え" :active.sync="activeChangeModeHTML"
                  button-close-hidden>
            <div>
          <span>
            テキストモードに切り替えると、このメッセージのすべての書式設定とインライン画像が削除されます。
          </span>
                <br>
                <span>続けますか？</span>
            </div>
            <div class="flex justify-end">
                <vs-button @click="modeHTML = false;activeChangeModeHTML = false" color="success" icon="check"
                           style="padding: 8px; margin-right: 5px;height: 37px">はい
                </vs-button>
                <vs-button @click="activeChangeModeHTML = false" color="lightgrey" icon="cancel"
                           style="padding: 8px; margin-right: 5px;height: 37px">キャンセル
                </vs-button>
            </div>
        </vs-popup>

    </div>
    <div v-else class="mt-5 select-history vx-card p-6">

        <div class="pt-6 mb-4 container-wrap">
            <div class="flex flex-wrap">
                <!----Send mode------>
                <div class="btn-groups-tab-2 ml-3">
                    <vs-button color="white" class="tab-send-mail-tab-2"
                               @click="setTab(1)"><span class="text-not-active">送信</span>
                    </vs-button>
                    <vs-button color="#0F86F5" class="tab-history tab-active-tab-2"
                               @click="setTab(2)"><span :class="tabActive == 1 ? 'text-not-active' : ''">履歴</span>
                    </vs-button>
                </div>
            </div>
        </div>
            <div class="select-broadcast">
                <v-select
                        name="対象項目"
                        :searchable="false"
                        v-validate.immediate="'required'"
                        class="vx-col sm:w-3/4 w-full"
                        v-model="itemTarget"
                        :clearable="false"
                        :options="itemTargetOptions"
                        :reduce="itemTargetOptions => itemTargetOptions.value">
                        <div slot="no-options">一斉送信グループオプションはありません。</div>
                </v-select>
            </div>


            <div class="static mt-5 ml-2 mb-5 flex-row">
                <div class="mt-2"><div>送信総件数：{{this.countMailSend}} </div></div>
                <div class="mt-2"><div>送信済件数：{{this.countMailSendSuccess}}</div></div>
                <div class="mt-2"><div>開封件数：{{this.countMailIsRead}}</div></div>
                <div class="mt-2"><div>開封率：{{rateMailRead}}%</div></div>
                <div class="output-csv d-flex justify-end">
                </div>
            </div>

            <vs-row class="pl-2">
                <vs-col class="flex flex-wrap items-center justify-start" vs-w="6">
                    <span class="pr-2">表示件数:</span>
                    <div class="vx-col md:w-24 w-full">
                        <v-select class=" sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                                  :options="paginationOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  :clearable="false"
                                  v-model="paginationPageSize">
                        </v-select>
                    </div>
                </vs-col>
                <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="6">
                    <vue-json-to-csv ref="exportCSV" style="display: none" csv-title="MailReceived_CSV"
                                     :labels="labelExport" :json-data="dataExport"></vue-json-to-csv>
                    <vs-button :disabled="sendMailsRender.length == 0 || isRead" color="#0F86F5" @click="onExportCSV()">CSV出力</vs-button>
                </vs-col>
            </vs-row>

            <ag-grid-vue
                    id="myGrid"
                    ref="agGridTable"
                    @grid-ready="onGridReady"
                    :gridOptions="gridOptionsSignature"
                    class="ag-theme-material w-100 my-4 ag-grid-table-send-mail database"
                    :columnDefs="columnDefsBroadcast"
                    :defaultColDef="defaultColDef"
                    :rowData="sendMailsRender"
                    rowSelection="multiple"
                    colResizeDefault="shift"
                    :animateRows="true"
                    :pagination="true"
                    :domLayout="domLayout"
                    :paginationPageSize="paginationPageSize"
                    :suppressPaginationPanel="true"
                    :enableRtl="$vs.rtl"
                    :overlayNoRowsTemplate="noRowsTemplate"
                    :detailRowAutoHeight="false"
                    @sortChanged="onSortChangedEvent"
            >
            </ag-grid-vue>

            <div style="position: relative">
                <!-- ITEMS PER PAGE -->
                <div>
                    <div class="flex items-center justify-between">
                        <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
                    </div>
                </div>
            </div>
        <div class="paginate">
            <vs-pagination
                :total="totalPages"
                v-model="currentPage"
                :max="7"
                class="pr-10 pt-10 w-full"
        />
        </div>


    </div>

</template>

<script>
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import vSelect from 'vue-select'
    import {quillEditor} from "vue-quill-editor";
    import {mapActions, mapGetters} from 'vuex'
    import {getColumnLimit, getMaximumSizeAttachment} from '../utils/settings';
    import {getLS} from '../utils/localStorage-utils';
    import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
    import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
    import {AgGridVue} from "ag-grid-vue";
    import htmlToFormattedText from 'html-to-formatted-text';
    import {Html5Entities} from "html-entities";
    import {htmlToText} from "html-to-text";
    import Contacts  from '../components/Contacts.vue';
    import EventBus from "../EventBus";
    import Papa from 'vue-papa-parse';

    export default {
        components: {
            quillEditor,
            vSelect,
            AgGridVue,
            htmlToFormattedText,
            Html5Entities,
            htmlToText,
            Contacts
        },
        data() {
            return {
                countMailSend:0,
                countMailSendSuccess:0,
                countMailIsRead:0,
                rateMaiSend:0,
                sendMails: [],
                sendMailsCoppy: [],
                sendMailsRender: [],
                select1: 2,
                options1: [
                    {text: 'IT', value: 0},
                    {text: 'Blade Runner', value: 2},
                    {text: 'Thor Ragnarok', value: 3},
                ],
                itemTarget: null,
                itemTargetOptions: [],
                labelExport: Object.assign({
                    id: {title: 'ID'},
                    to: {title: 'To'},
                    status_send: {title: '送信状況'},
                    status_read: {title: '開封状況'},
                }),
                dataExport: [],
                tabActive: 1,
                paginationPageSize: 10,
                paginationOptions: [
                    10, 20, 30, 50
                ],
                orderBy: 'id',
                orderDir: 'asc',
                pageNumber: 1,
                value: '',
                receive_mail: {},
                countReplyMail: null,
                activeSend: false,
                activeShow: false,
                isRead: false,
                isReport: false,
                viewMailSent: false,
                viewMailDraft: false,
                prevRoute: '',
                mailTo: '',
                mailCC: '',
                mailBCC: '',
                mailFrom: '',
                inquiryType: {value: 0, label: 'メール'},
                type: {},
                listMstUserSelect: [
                    ''
                ],
                mst_user: {},
                listTypeSelect: [
                    ''
                ],
                listInquiryTypeSelect: [
                    {value: 0, label: 'メール'},
                    {value: 1, label: '電話'},
                    {value: 2, label: '営業'},
                    {value: 9, label: 'その他'}
                ],
                listMailFrom: [], // using in report-mail
                listMailTo: [],
                listMailCC: [],
                listMailBCC: [],
                files: [],
                mailSubject: '',
                mailMessage: '',
                sentDateTime: null,
                confirmSendWithoutSubject: false,
                confirmSendWithoutBody: false,
                modeHTML: true,
                activeChangeModeHTML: false,
                showDialogSend: true,
                isPreventDoubleClick: false,
                isCreated: false,
                messageError: '',
                editorOption: {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                            ['blockquote', 'code-block'],

                            [{'header': 1}, {'header': 2}],               // custom button values
                            [{'list': 'ordered'}, {'list': 'bullet'}],
                            [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
                            [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
                            [{'direction': 'rtl'}],                         // text direction

                            [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
                            [{'header': [1, 2, 3, 4, 5, 6, false]}],

                            [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                            [{'font': []}],
                            [{'align': []}],

                            ['clean'],                                         // remove formatting button

                            ['link', 'image', 'video']                         // link and image, video
                        ]
                    },
                    placeholder: ''
                },

                //dialog confirm mail-send without body or subject
                confirmQuestion: '',
                titleDialog: '',

                //dialog add template
                popupAdd: false,
                templateName: '',

                //Bulk mode
                bulkMode: true,

                //CSV file
                csv_file: null,  // for handle file
                csv_data: null,   // for handle json data
                csv_header: null, // for handle headers
                csv_raw: null,    // for handle render table
                listSettings: [],     // settings for CSV

                //Shachihata desk
                isEmbedded: this.$route.query.mode && this.$route.query.mode == 'sdsk',
                //AG gird
                noRowsTemplate: "<span>データがありません</span>",
                domLayout: "autoHeight",
                gridApi: null,
                defaultColDef: {
                    sortable: true,
                    resizable: true,
                    suppressMenu: true,
                    sortingOrder: ["asc", "desc"],
                },
                //Signature
                gridApiSignature: null,
                columnApiSignature: null,
                popUpSignature: false,
                gridOptionsSignature: {
                    onGridSizeChanged: () => {
                        this.gridApiSignature.sizeColumnsToFit();
                    },
                },
                columnDefsSignature: [
                    {
                        headerName: "",
                        width: 50,
                        checkboxSelection: true,
                    },
                    {
                        headerName: "名前",
                        field: "signature_name",
                        width: 100,
                        unSortIcon: true,
                        suppressMovable: true,
                    },
                    {
                        headerName: "署名",
                        field: "parsed_signature",
                        width: 300,
                        unSortIcon: true,
                        suppressMovable: true,

                    },
                ],
                columnDefsBroadcast: [
                    {
                        headerName: "ID",
                        width: 270,
                        field: "id",
                    },
                    {
                        headerName: "To",
                        width: 540,
                        unSortIcon: true,
                        field: "to",
                    },
                    {
                        headerName: "送信状況",
                        width: 270,
                        unSortIcon: true,
                        field: "state_flg",
                        valueFormatter: (params) => {
                            return this.displayStatusSendMail(params.value);
                        }
                    },
                    {
                        headerName: "開封状況",
                        width: 270,
                        unSortIcon: true,
                        field: "is_read",
                        valueFormatter: (params) => {
                            return this.displayStatusReadMail(params.value);
                        }

                    },
                ],
                signatureSelect: null,
                currentCursor: null,
                //
                isSendInNewTab: false,
                //
                updateMailDraft: null,
                isSetPreviousMail: false,
                isClickCloseButton: false,
                activeModelContacts: false,
                typeModalContact:'',
                showIconContacts: false,
            };
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            })
        },
        watch: {
            async paginationPageSize() {
                this.sendMailsRender = await this.getListMailSend(this.itemTarget)
                this.pageNumber = 1
            },
            async itemTarget(newVal) {
                this.sendMailsRender = await this.getListMailSend(newVal)
                this.pageNumber = 1
            },
            modeHTML() {
                if (this.isCreated) {
                    this.changeMessage();
                }
            },
            mailFrom(val) {
                if (this.isReport && this.$route.path.search(val) === -1) {
                    let url = new URL(window.location.href);
                    let close = url.searchParams.get("back");
                    if (close) {
                        this.$store.commit('receiveMail/SET_CURRENT_MAIL_BOX_SELECT', val)
                    } else {
                        this.$store.commit('receiveMail/SET_CURRENT_MAIL_BOX_SELECT', val)
                    }
                    this.autoSaveMailDraft();
                }
            },
            listMailTo(newVal, oldVal) {
                this.listMailTo.forEach(to => {
                    let toValue = to.split(";");
                    if (toValue && toValue.length > 1) {
                        this.listMailTo = this.listMailTo.filter(mail => mail !== to);
                        toValue.forEach(value => {
                            this.listMailTo.push(value)
                        });
                    }
                });
                if ((oldVal && oldVal.length > 0) || this.updateMailDraft) {
                    this.autoSaveMailDraft();
                }
                let listMailToUpdate = this.listMailTo.filter(item => {
                    return (item !== '' && item !== ' ')
                })
                if (listMailToUpdate.length !== this.listMailTo.length) {
                    this.listMailTo = listMailToUpdate
                }
            },
            listMailCC(newVal, oldVal) {
                this.listMailCC.forEach(cc => {
                    let ccValue = cc.split(";");
                    if (ccValue && ccValue.length > 1) {
                        this.listMailCC = this.listMailCC.filter(mail => mail !== cc);
                        ccValue.forEach(value => {
                            this.listMailCC.push(value)
                        });
                    }
                });
                if ((oldVal && oldVal.length > 0) || this.updateMailDraft) {
                    this.autoSaveMailDraft();
                }
                let listMailCCUpdate = this.listMailCC.filter(item => {
                    return (item !== '' && item !== ' ')
                })
                if (listMailCCUpdate.length !== this.listMailCC.length) {
                    this.listMailCC = listMailCCUpdate
                }
                this.$refs.vsChipCc.newChip = "";
                this.$nextTick(() => {
                    let vschipsCc = document.getElementById('vschipCcs').clientHeight;
                    document.getElementById('contacts_dropdown_CC').style.top = vschipsCc + 'px';
                });
            },
            listMailBCC(newVal, oldVal) {
                this.listMailBCC.forEach(bcc => {
                    let bccValue = bcc.split(";");
                    if (bccValue && bccValue.length > 1) {
                        this.listMailBCC = this.listMailBCC.filter(mail => mail !== bcc);
                        bccValue.forEach(value => {
                            this.listMailBCC.push(value)
                        });
                    }
                });
                if ((oldVal && oldVal.length > 0) || this.updateMailDraft) {
                    this.autoSaveMailDraft();
                }
                let listMailBCCUpdate = this.listMailBCC.filter(item => {
                    return (item !== '' && item !== ' ')
                })
                if (listMailBCCUpdate.length !== this.listMailBCC.length) {
                    this.listMailBCC = listMailBCCUpdate
                }
                this.$refs.vsChipBcc.newChip = "";
                this.$nextTick(() => {
                    let vschipsBcc = document.getElementById('vschipBccs').clientHeight;
                    document.getElementById('contacts_dropdown_BCC').style.top = vschipsBcc + 'px';
                });
            },
            files(newVal, oldVal) {
                if ((oldVal && oldVal.length > 0) || this.updateMailDraft) {
                    this.autoSaveMailDraft();
                }
            },
            inquiryType(newVal, oldVal) {
                if (oldVal != 0 || this.updateMailDraft) {
                    this.autoSaveMailDraft();
                }
            },
            type(newVal, oldVal) {
                if (oldVal != 0 || this.updateMailDraft) {
                    this.autoSaveMailDraft();
                }
            },
            mst_user(newVal, oldVal) {
                if (oldVal != 0 || this.updateMailDraft) {
                    this.autoSaveMailDraft();
                }
            },
            mailMessage(newVal, oldVal) {
                if (oldVal != 0 || this.updateMailDraft) {
                    this.autoSaveMailDraft();
                }
            },
            mailSubject(newVal, oldVal) {
                if (oldVal !== '' || this.updateMailDraft) {
                    this.autoSaveMailDraft();
                }
            },
            tabActive(newVal, oldVal){
                if(newVal == 1){
                    this.$nextTick(() => {
                        //Start process contacts dropdown
                        this.styleContactListDropdown('contacts_dropdown_CC',"vschipCcs");
                        this.styleContactListDropdown('contacts_dropdown_BCC',"vschipBccs");
                        //End process contacts dropdown
                    })
                }
            },
            '$route.params.email': async function(newVal, oldVal){
                this.isRead = await this.setUserReadOnly(newVal) > 0;
            }
           
        },
        computed: {
            ...mapGetters({
                mailThreadView: 'receiveMail/getMailThreadView',
                listMailTemplate: 'templateMail/listMailTemplate',
                listUserSignature: "userSignature/listUserSignature",
                preMailDraft: "mailDraft/preMailDraft",
                listMailBox: "receiveMail/listMailBox",
                listContactComputed: 'contact/getContactList',
            }),
            validateForm() {
                if (!this.inquiryType.label) {
                    this.messageError = '方法は必須です。'
                    return false
                }
                if (!this.type.label) {
                    this.messageError = '種別は必須です。'
                    return false
                }
                // Email To is required
                if (!this.bulkMode && this.listMailTo.length == 0 && this.mailTo == '') {
                    this.messageError = 'Toは必須です。'
                    return false
                }
                // validateEmail in listMail
                if (!this.bulkMode && this.listMailTo.length > 0) {
                    let to = this.listMailTo.find(to => this.validateEmail(to) == false)
                    if (to) {
                        this.messageError = 'メールアドレス形式が正しくありません。'
                        return false
                    }
                }
                if (this.listMailCC.length > 0) {
                    let cc = this.listMailCC.find(cc => this.validateEmail(cc) == false)
                    if (cc) {
                        this.messageError = 'メールアドレス形式が正しくありません。'
                        return false
                    }
                }
                if (this.listMailBCC.length > 0) {
                    let bcc = this.listMailBCC.find(bcc => this.validateEmail(bcc) == false)
                    if (bcc) {
                        this.messageError = 'メールアドレス形式が正しくありません。'
                        return false
                    }
                }

                // validateEmail on input: if not press 'enter' to add listMail
                if (!this.bulkMode && this.mailTo && !this.validateEmail(this.mailTo)) {
                    this.messageError = 'メールアドレス形式が正しくありません。'
                    return false
                }
                if (this.mailCC && !this.validateEmail(this.mailCC)) {
                    this.messageError = 'メールアドレス形式が正しくありません。'
                    return false
                }
                if (this.mailBCC && !this.validateEmail(this.mailBCC)) {
                    this.messageError = 'メールアドレス形式が正しくありません。'
                    return false
                }

                //check attach files length > 1 && file size
                // if(this.files.length > 1){
                //   this.messageError = '添付ファイルが多くて、圧縮ファイルにしてください。'
                //   return false
                // }
                let totalSize = 0
                let maxSize = parseInt(getMaximumSizeAttachment(this.listSettings));
                this.files.forEach(file => totalSize += file.size)
                if(totalSize > maxSize*1024*1024){
                    this.messageError = 'ファイル容量は'+maxSize+'MB以下でアップロードしてください。';
                    return false
                }
                if (!this.inquiryType || (this.inquiryType && this.inquiryType.label == "...")) {
                    this.messageError = '方法をご選択ください。'
                    return false
                }
                if (!this.type || (this.type && this.type.label == "...")) {
                    this.messageError = '種別をご選択ください。'
                    return false
                }
                if (!this.mst_user || (this.mst_user && this.mst_user.value == "")) {
                    this.messageError = '担当者をご選択ください。'
                    return false
                }
                if (this.mailSubject.length > 512) {
                    this.messageError = '件名は512文字以下で指定ください。'
                    return false
                }

                this.messageError = ''
                return true
            },
            validateTemplate() {
                if (this.templateName == '') {
                    this.messageError = 'テンプレート名を入力してください。';
                    return false;
                } else if (this.mailMessage == '') {
                    this.messageError = 'テンプレートの内容を入力してください。';
                    return false;
                }

                this.messageError = '';
                return true;
            },
             listUserSignatureComputed() {
                let fetchListUserSignature = this.listUserSignature
                let listUserSignature = [];
                 fetchListUserSignature.forEach((element) => {
                    listUserSignature.push(
                        Object.assign({...element, parsed_signature: element.parsed_signature})
                    );
                });
                return listUserSignature;
            },
            sendMailButtonDisable() {
                return (this.bulkMode && !this.csv_data) || (!this.bulkMode && this.listMailTo.length == 0 && !this.mailTo) || this.isRead
            },
            totalPages() {
                return parseInt(this.$store.state.broadcast.infoDB.totalPage) || 1
            },
            rateMailRead() {
                return this.countMailSendSuccess === 0 ? 0 : (Number)(this.countMailIsRead/this.countMailSendSuccess)*100;
            },
            totalRow() {
               return this.countMailSend;
            },
            startRow() {
                if (this.countMailSend === 0) {
                    return 0
                } else {
                    return (Number)(this.paginationPageSize * ( this.pageNumber- 1)) + 1;
                }
            },
            endRow() {
                if (this.countMailSend === 0) {
                    return 0
                } else {
                    return Math.min((Number)(this.paginationPageSize * ( this.pageNumber- 1)) + this.paginationPageSize, this.countMailSend);
                }
            },
            currentPage: {
                get() {
                    return this.pageNumber
                },
                async set(val) {
                    this.pageNumber = val
                    this.sendMailsRender = await this.getListMailSend(this.itemTarget);
                }
            },
        },
        mounted() {
            this.$nextTick(() => {
                //Start process contacts dropdown
                this.styleContactListDropdown('contacts_dropdown_CC',"vschipCcs");
                this.styleContactListDropdown('contacts_dropdown_BCC',"vschipBccs");
                //End process contacts dropdown
            })
            if (this.isReport) {
                window.addEventListener('popstate', this.onBack);
            }

            const root = this
            window.addEventListener('beforeunload', function () {
                sessionStorage.setItem("currentMailBox", root.prevRoute.params.email)
                if ((!root.isClickCloseButton && root.isReport) || (!root.isClickCloseButton && root.$route.name === 'reply-mail')) {
                    let listTo = root.listMailTo.map(mail => mail)
                    if (root.mailTo) {
                        listTo = listTo.concat(root.mailTo.split(";"));
                    }
                    let listCC = root.listMailCC.map(mail => mail)
                    if (root.mailCC) {
                        listCC = listCC.concat(root.mailCC.split(";"));
                    }
                    let listBCC = root.listMailBCC.map(mail => mail)
                    if (root.mailBCC) {
                        listBCC = listBCC.concat(root.mailBCC.split(";"));
                    }
                    let mailData = {
                        body_type: root.modeHTML,
                        to: listTo,
                        from: root.mailFrom,
                        subject: root.mailSubject,
                        body: root.mailMessage,
                        cc: listCC,
                        bcc: listBCC,
                        files: root.files,
                        inquiry_type: root.inquiryType.value,
                        type: root.type.value,
                        mst_user_id: root.mst_user.value,
                        mail_type: 'draft',
                    }
                    if (root.$route.params.send_mail_id) mailData['id'] = parseInt(root.$route.params.send_mail_id)
                    else {
                        if (root.updateMailDraft) {
                            mailData['id'] = root.updateMailDraft
                        }
                    }
                    localStorage.setItem('dataSaveDraft', JSON.stringify(mailData));
                    localStorage.setItem('refreshPage', 'draft');
                }
            })
            for (let index = 0; index < document.getElementsByClassName('con-chips--input').length; index++) {
                document.getElementsByClassName('con-chips--input')[index].addEventListener('input', function () {
                    let valueInput = document.getElementsByClassName('con-chips--input')[index].value
                    if (valueInput.length > 0) {
                        valueInput = valueInput.trimStart()
                        // valueInput = valueInput.replaceAll('\t','')
                        document.getElementsByClassName('con-chips--input')[index].value = valueInput
                    }
                    if (index == 0) {
                        root.mailTo = document.getElementsByClassName('con-chips--input')[index].value
                    }
                    if (index == 1) {
                        root.mailCC = document.getElementsByClassName('con-chips--input')[index].value
                    }
                    if (index == 2) {
                        root.mailBCC = document.getElementsByClassName('con-chips--input')[index].value
                    }
                });
            }
            for (let index = 0; index < document.getElementsByClassName('con-chips--input').length; index++) {
                document.getElementsByClassName('con-chips--input')[index].addEventListener('blur', function () {
                    let valueInput = document.getElementsByClassName('con-chips--input')[index].value
                    if (valueInput.length > 0) {
                        valueInput = valueInput.trim()
                        // valueInput = valueInput.replaceAll('\t','')
                        document.getElementsByClassName('con-chips--input')[index].value = valueInput
                    }
                    if (index == 0) {
                        root.mailTo = document.getElementsByClassName('con-chips--input')[index].value
                    }
                    if (index == 1) {
                        root.mailCC = document.getElementsByClassName('con-chips--input')[index].value
                    }
                    if (index == 2) {
                        root.mailBCC = document.getElementsByClassName('con-chips--input')[index].value
                    }
                });
            }
            EventBus.$on("applyContactsTo", (listMailToSelected,typeModalContact) => {
            const regexMail = /<([^<>]+?)>/;
            let listSelectedMail = listMailToSelected.map(email => regexMail.exec(email)[1]);
            if (typeModalContact === 'TO') {
                this.listMailTo = this.removeDuplicates([...this.listMailTo, ...listSelectedMail]);
            } else if (typeModalContact === 'CC') {
                this.listMailCC = this.removeDuplicates([...this.listMailCC, ...listSelectedMail]);
            } else if (typeModalContact === 'BCC') {
                this.listMailBCC = this.removeDuplicates([...this.listMailBCC, ...listSelectedMail]);
            }
            });
            EventBus.$on("disableModelContacts", () => {
                this.activeModelContacts = false
            });
        },
        methods: {
            ...mapActions({
                replyMail: 'moduleEmail/replyMail',
                createMail: 'moduleEmail/createMail',
                getMailReceive: 'receiveMail/getReceiveMailDetail',
                getListThread: 'receiveMail/getListThread',
                downloadFile: "receiveMail/downloadAttachment",
                getMailSent: 'moduleEmail/getMailSent',
                getListMailBoxSend: 'receiveMail/getListMailBoxSend',
                getListMailBox: 'receiveMail/getListMailBox',
                getListBroadCast: 'broadcast/getListBroadCast',
                getListMailSendByBroadcastId: 'broadcast/getListMailSendByBroadcastId',
                exportMailSend: 'broadcast/exportMailSend',
                getListKinds: 'kinds/getListKinds',
                getListMailTemplate: 'templateMail/getListMailTemplate',
                deleteMailTemplate: 'templateMail/deleteMailTemplate',
                addMailTemplate: 'templateMail/addMailTemplate',
                getListSettings: 'settings/getListSettings',
                handleShachihataDeskLogin: 'loginModule/handleShachihataDeskLogin',
                getUserSignature: "userSignature/getUserSignature",
                saveMailDraft: "mailDraft/saveMailDraft",
                getListUserDataSelect: "receiveMail/getListUserDataSelect",
                getDataExportCSV: "receiveMail/getDataExportCSV",
                fetchContactList: "contact/fetchContactList",
                setUserReadOnly: "receiveMail/setUserReadOnly",
            }),
            async onSortChangedEvent(event) {
                let columns = event.columnApi.getAllColumns();
                let root = this;
                for (const column of columns) {
                    if (column.getSort()) {
                        root.orderDir = column.getSort()
                        root.orderBy = column.getColId()
                        root.getListMailSend(root.itemTarget);
                        root.sendMailsRender = await root.getListMailSend(root.itemTarget);
                        return ;
                    }
                }

            },
            async getListMailSend(idBroadcast) {
               let listMailSend  = await this.getListMailSendByBroadcastId({
                    orderBy: this.orderBy,
                    idBroadcast: idBroadcast,
                    orderDir: this.orderDir,
                    limit: this.paginationPageSize,
                    page: this.pageNumber
                })
               this.countMailSend = listMailSend.count_total
               this.countMailSendSuccess = listMailSend.count_send_success
               this.countMailIsRead = listMailSend.count_is_read
                return listMailSend.data.data
            },
            onGridReady(params) {
                this.gridApi = params.api;
                this.gridColumnApi = params.columnApi;

                params.api.sizeColumnsToFit();
                window.addEventListener('resize', function () {
                    setTimeout(function () {
                        params.api.sizeColumnsToFit();
                    });
                });

                params.api.sizeColumnsToFit();
            },
            async exportMailSendToCSV(idBroadcast) {
               return await this.exportMailSend({
                    idBroadcast: idBroadcast,
                })
            },
            handleFiles(Event) {
                const toBase64 = file => new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
                let fileInput = Object.values(Event.target.files);
                fileInput.forEach(file => {
                    if (file.size == 0) {
                        this.$vs.notify({
                            position: 'bottom-right',
                            text: file.name + 'ファイル容量が0となっているので、添付できません。',
                            color: 'danger'
                        })
                    } else {
                        toBase64(file).then(res => {
                            let maxSize = parseInt(getMaximumSizeAttachment(this.listSettings));
                            if (file.size > maxSize * 1024 * 1024) throw 'ファイル容量は' + maxSize + 'MB以下でアップロードしてください。';
                            let pos = res.indexOf("base64,");
                            res = res.substring(pos + 7);
                            let fileEncode = {
                                "file_name": file.name,
                                "mime": file.type,
                                "file_content": res,
                                "size": file.size
                            }
                            this.files.push(fileEncode);
                        })
                            .catch(err => {
                                this.$vs.notify({
                                    position: 'bottom-right',
                                    text: err,
                                    color: 'danger'
                                })
                            })
                    }
                })
            },
            async downloadAttachment(file) {
                let data = {
                    "id": this.$route.params.send_mail_id,
                    "fileName": file,
                }
                let result = await this.downloadFile(data);
                if (result) {
                    const content = result.file_data;
                    let fileName = result.file_name;
                    let typeDownload = result.file_type;
                    // Decode base64 using atob method
                    let data = window.atob(content);
                    let bytes = new Array(data.length);
                    for (let i = 0; i < data.length; i++) {
                        bytes[i] = data.charCodeAt(i);
                    }
                    data = new Uint8Array(bytes);
                    let anchor = document.createElement('a');
                    if (anchor.download !== undefined) {
                        let blob = new Blob([data], {type: typeDownload});
                        var objectURL = window.URL.createObjectURL(blob);

                        anchor.href = objectURL;
                        anchor.download = fileName;
                    }
                    if (navigator.msSaveBlob) { // IE 10+
                        anchor.addEventListener("click", function (event) {
                            let blob = new Blob([data], {
                                "type": 'text'
                            });
                            navigator.msSaveBlob(blob, fileName);
                        }, false);
                    }

                    anchor.click();

                    URL.revokeObjectURL(objectURL);
                }
            },
            removeFile(index) {
                this.files.splice(index, 1);
            },

            async onSaveDraft(action) {

                // copy listMail => fix error duplicate
                let listTo = this.listMailTo.map(mail => mail)
                if (this.mailTo) {
                    listTo = listTo.concat(this.mailTo.split(";"));
                }
                let listCC = this.listMailCC.map(mail => mail)
                if (this.mailCC) {
                    listCC = listCC.concat(this.mailCC.split(";"));
                }
                let listBCC = this.listMailBCC.map(mail => mail)
                if (this.mailBCC) {
                    listBCC = listBCC.concat(this.mailBCC.split(";"));
                }
                let mailData = {
                    body_type: this.modeHTML ? 'HTML' : 'Text',
                    to: listTo,
                    from: this.mailFrom,
                    subject: this.mailSubject,
                    body: this.mailMessage,
                    cc: listCC,
                    bcc: listBCC,
                    files: this.files,
                    inquiry_type: this.inquiryType.value,
                    type: this.type.value,
                    mst_user_id: this.mst_user.value,
                    mail_type: 'draft',
                }

                if (action != 'duplicate') {
                    // For update
                    if (this.$route.params.send_mail_id) mailData['id'] = parseInt(this.$route.params.send_mail_id)
                    else {
                        if (this.updateMailDraft) {
                            mailData['id'] = this.updateMailDraft
                        }
                    }
                } else {
                    mailData['id'] = null
                }
                if (this.inquiryType.value || this.type.value ||
                    listTo.length > 0 || listCC.length > 0 || listBCC.length > 0 ||
                    this.files.length > 0 || this.mailSubject != '' || this.mailMessage != '') {
                    localStorage.setItem('noLoading', true);
                    let success = await this.saveMailDraft(mailData)
                    if (success) {
                        this.updateMailDraft = success;
                        localStorage.setItem('refreshPage' , 'draft');
                    }
                }
            },
            async onSaveDraftDuplicate() {
                await this.onSaveDraft('duplicate');
            },
            beforeSendMail() {
                if (!this.validateForm) {
                    this.$vs.notify({
                        position: 'bottom-right',
                        text: this.messageError,
                        color: 'danger'
                    })
                } else {
                    this.totalConfirmTime = 0
                    this.showDialogSend = true
                    if (this.mailSubject && this.mailMessage) {
                        if (this.bulkMode) this.sendBulk();
                        else this.send();
                    } else {
                        if (!this.mailSubject) {
                            this.totalConfirmTime++
                        }
                        if (!this.mailMessage) {
                            this.totalConfirmTime++
                        }
                        this.confirmDialogBeforeSend()
                    }
                }
                this.isPreventDoubleClick = true
                setTimeout(() =>{
                    this.isPreventDoubleClick = false
                },1000)

            },
            setTab(tabValue) {
                this.tabActive = tabValue
            },
            confirmDialogBeforeSend() {
                if (!this.mailSubject) {
                    this.confirmQuestion = '件名内容なしでメール送信しますか？'
                    this.titleDialog = '件名内容確認'
                    this.activeSend = true
                } else if (!this.mailMessage) {
                    this.confirmQuestion = '返信内容なしでメール送信しますか？'
                    this.titleDialog = '返信内容確認'
                    this.activeSend = true
                }
            },
            confirm() {
                this.totalConfirmTime--
                if (this.totalConfirmTime === 0) {
                    if (this.bulkMode) this.sendBulk();
                    else this.send();
                }
                if (this.totalConfirmTime > 0) {
                    this.confirmQuestion = '返信内容なしでメール送信しますか？'
                    this.titleDialog = '返信内容確認'
                    this.activeSend = true
                }
                this.isPreventDoubleClick = true
                setTimeout(() =>{
                    this.isPreventDoubleClick = false
                },1000)
            },
            async send() {
                // copy listMail => fix error duplicate
                let listTo = this.listMailTo.map(mail => mail)
                if (this.mailTo) {
                    listTo = listTo.concat(this.mailTo.split(";"));
                }
                let listCC = this.listMailCC.map(mail => mail)
                if (this.mailCC) {
                    listCC = listCC.concat(this.mailCC.split(";"));
                }
                let listBCC = this.listMailBCC.map(mail => mail)
                if (this.mailBCC) {
                    listBCC = listBCC.concat(this.mailBCC.split(";"));
                }

                // set data send
                let mailData = {
                    body_type: this.modeHTML ? 'HTML' : 'Text',
                    to: listTo,
                    from: this.mailFrom,
                    subject: this.mailSubject,
                    body: this.mailMessage,
                    cc: listCC,
                    bcc: listBCC,
                    files: this.files,
                    inquiry_type: this.inquiryType.value,
                    type: this.type.value,
                    mst_user_id: this.mst_user.value,
                    delete_draft: !this.viewMailDraft ? this.updateMailDraft : null
                }

                // For update
                if (this.$route.params.send_mail_id) mailData['id'] = parseInt(this.$route.params.send_mail_id)

                let success
                if (this.receive_mail.receive_mail_id) {
                    mailData.mail_id = this.receive_mail.id
                    success = await this.replyMail(mailData)
                    this.isSendInNewTab = true;
                } else {
                    success = await this.createMail(mailData)
                    this.isSendInNewTab = true;
                }

                if (success) {
                    if (this.$route.query.mode == 'sdsk') {
                        this.sendPostMessage('send', true);
                        return;
                    }
                    this.onBack();
                } else {
                    if (this.$route.query.mode == 'sdsk') {
                        this.sendPostMessage('send', false);
                        return;
                    }
                }
            },
            validateEmail(emails) {
                if (emails.length > 0) {
                    emails = emails.trim()
                }
                let success = true;
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let listEmails = emails.split(";");
                for (let i = 0; i < listEmails.length; i++) {
                    if (!re.test(String(listEmails[i]).toLowerCase())) {
                        success = false;
                        break;
                    }
                }
                return success;
            },
            async onBack() {
                this.$router.go(-1);
            },

            //Mail template methods
            deleteTemplate: async function (id) {
                try {
                    //Delete mail template
                    await this.deleteMailTemplate({
                        user_id: this.$store.state.AppActiveUser.id,
                        id
                    });
                    //Update list mail template
                    await this.getListMailTemplate({user_id: this.$store.state.AppActiveUser.id});
                } catch (error) {
                    console.log(error);
                }
            },
            async getListKindsSelect() {
                let response = await this.getListKinds()
                if (response) {

                    this.listTypeSelect = [
                        {
                            label: '...',
                            value: ''
                        }
                    ]
                    response.map(element => {
                        let result = {}
                        result.value = element.type_id
                        result.label = element.kinds_name
                        this.listTypeSelect.push(result)
                    })
                } else {
                    this.listTypeSelect = [
                        {
                            label: '...',
                            value: ''
                        }
                    ]
                }
            },

            async getListSettingsSelect() {
                let response = await this.getListSettings()
                if (response) {
                    this.listSettings = [];
                    response.map(element => this.listSettings.push(element));
                } else {
                    this.listSettings = [];
                }
            },
            async getListMstUserSelect() {
                let mailBoxInfo = await this.listMailBox.find(
                    (element) => element.receive_user_name == this.$route.params.email
                );
                if (mailBoxInfo) {
                    let params = {
                        mst_mail_server_id: mailBoxInfo.id,
                    };
                    let response = await this.getListUserDataSelect(params);
                    if (response) {
                        this.listMstUserSelect = [
                            {
                                label: "...",
                                value: "",
                            },
                        ];
                        response.map((element) => {
                            let result = {};
                            result.value = element.id;
                            result.label = element.full_name;
                            this.listMstUserSelect.push(result);
                        });
                    } else {
                        this.listMstUserSelect = [
                            {
                                label: "...",
                                value: "",
                            },
                        ];
                    }
                }
            },
            addTemplate: async function () {
                //Check template name and content
                if (!this.validateTemplate) {
                    this.$vs.notify({
                        position: 'bottom-right',
                        text: this.messageError,
                        color: 'danger'
                    })
                } else {
                    try {
                        //Add mail template
                        await this.addMailTemplate({
                            user_id: this.$store.state.AppActiveUser.id,
                            template_name: this.templateName,
                            template_content: this.mailMessage,
                            template_mode: this.modeHTML ? 1 : 0,
                        });

                        //Update list mail template
                        await this.getListMailTemplate({user_id: this.$store.state.AppActiveUser.id});

                        this.hidePopupAddMail();
                    } catch (error) {
                        console.log(error);
                    }
                }
            },

            displayTemplate: function (id) {
                const template = this.listMailTemplate.filter(item => item.id == id);
                this.mailMessage = template[0].template_content;
                this.modeHTML = template[0].template_mode == 1;
            },
            hidePopupAddMail: function () {
                this.templateName = '';
                this.popupAdd = false;
            },

            //CSV Upload methods
            handleCSVFile(e) {
                //Validate file input
                const file = e.target.files[0];
                if (file.name.split('.').pop() != 'csv') {
                    this.messageError = "ファイルの形式はCSVファイルではありません。";
                    this.$vs.notify({
                        position: 'bottom-right',
                        text: this.messageError,
                        color: 'danger'
                    });
                    return;
                }

                const processCSVData = dataArr => {
                    let keyArr = [], objects = [];
                    this.csv_raw = [];
                    //2D array with key (pos 0) and values (res)
                    dataArr.map((row, index) => {
                        if (index == 0) {
                            keyArr = row;
                            //Set csv_header
                            this.csv_header = keyArr;
                        } else {
                            let object = {};
                            this.csv_raw.push(row);
                            row.map((value, idx) => {
                                if (!object[keyArr[idx]]) object[keyArr[idx]] = value;
                            });
                            objects.push(object);
                        }
                    });
                    this.csv_data = objects;
                };

                //Convert to json
                this.$papa.parse(file, {
                    encoding: 'Shift_JIS',
                    skipEmptyLines: true,
                    delimiter: [',', '\t', '|', ';'],
                    delimitersToGuess: [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP],
                    complete: (results, file) => {
                        try {
                            const dataArr = results.data.filter((row) => row.length > 0);
                            this.validateCSV(dataArr) && processCSVData(dataArr);
                            //Set the name of csv file
                            this.csv_file = file.name;
                        } catch (error) {
                            this.messageError = error;
                             this.$vs.notify({
                                position: 'bottom-right',
                                text: this.messageError,
                                color: 'danger',
                            });
                        }
                    },
                    error: (error) => {
                        this.messageError = error;
                        this.$vs.notify({
                            position: 'bottom-right',
                            text: this.messageError,
                            color: 'danger'
                        });
                    },
                });
            },

            removeCSVFile(e) {
                this.csv_file = null;
                this.csv_data = null;
                this.csv_header = null;
                this.csv_raw = null;
            },
            removeEmptyElements(data){
                if(data.length == 0) return data;
                return data.filter((item) => {
                    return item !== null && item !== undefined && item !== "";
                });
            },
            validateCSV(dataArr) {
                const headerArr = dataArr[0];
                //Check column header
                if (headerArr.length > getColumnLimit(this.listSettings)) throw 'CSVファイルは無効です。制限の列数を超えました。';

                //Check column header not empty
                headerArr.map((ele, index) => {
                    if (ele == '') throw `CSVファイルは無効です。#${index + 1}列のタイトルは空となっています。`;
                });

                const noCol = headerArr.length;
                //Check csv format
                dataArr.map((ele, index) => {
                    //Check row is not empty
                    if (ele == '') throw `CSVファイルは無効です。#${index + 1}行は空となっています。`;
                    //Check column length
                    if (ele.length != noCol) throw `CSVファイルは無効です。#${index + 1}行をチェックしてください。`;
                });

                //Check to column
                const toIdx = headerArr.findIndex(ele => /\bto\b/gi.test(ele));

                this.toHeader = null;
                if (toIdx != -1) {
                    this.toHeader = headerArr[toIdx];
                    //Check to column
                    for (let i = 1; i < dataArr.length; i++) {
                        const rowData = dataArr[i];
                        if (!this.validateEmail(rowData[toIdx])) {
                            throw `CSVファイルは無効です。TOアドレスが正しくありません。${headerArr[toIdx]}: ${rowData[toIdx]}（${i + 1}行目 ）`;
                        }
                    }
                    return true;
                } else {
                    throw `CSVファイルは無効です。TOアドレスを入力してください。`;
                }
            },

            //Bulk send method
            async sendBulk() {
                //Validate header in mail body
                const regex = /{([^}]+)}/g;
                const headers = this.mailMessage.match(regex);
                let isFailed = false;
                headers && headers.map(header => {
                    if (this.csv_header.indexOf(header.replaceAll(/\{|\}/g, '')) == -1) {
                        this.messageError = header + "フィールドが見つかりません。";
                        this.$vs.notify({
                            position: 'bottom-right',
                            text: this.messageError,
                            color: 'danger'
                        });
                        isFailed = true;
                    }
                });
                if (isFailed) return;

                let listCC = this.listMailCC.map(mail => mail)
                if (this.mailCC) {
                    listCC = listCC.concat(this.mailCC.split(";"));
                }
                let listBCC = this.listMailBCC.map(mail => mail)
                if (this.mailBCC) {
                    listBCC = listBCC.concat(this.mailBCC.split(";"));
                }
                let listMailTo = [];
                let listPrefixMessage = [];
                //Loop through list csv_data
                let successAll = false;

                for (let i = 0; i < this.csv_data.length; i++) {
                    const data = this.csv_data[i];
                    //Parse mail message
                    let infoCustomer = '';
                    for (const key of ['企業名', '宛名']) {
                        if (Object.hasOwnProperty.call(data, key)) {
                            infoCustomer += data[key] ? `<p>${data[key]}</p>` :'';
                        }
                    }
                    if(infoCustomer) infoCustomer += `<p><br></p>`;
                    let message = infoCustomer + this.mailMessage;
                    this.csv_header.map(header => message = message.replaceAll(`{${header}}`, data[header]));
                    listMailTo.push(data[this.toHeader]);
                    listPrefixMessage.push(infoCustomer);
                }
                ;
                let mailData = {
                    body_type: 'HTML',
                    to: listMailTo,
                    from: this.mailFrom,
                    subject: this.mailSubject,
                    body    : this.mailMessage,
                    prefixBody: listPrefixMessage,
                    cc: listCC,
                    bcc: listBCC,
                    files: this.files,
                    inquiry_type: this.inquiryType.value,
                    type: this.type.value,
                    mst_user_id: this.mst_user.value,
                    send_type: 'bulk',
                    broadcast: true,
                    delete_draft: !this.viewMailDraft ? this.updateMailDraft : null
                }
                if (this.$route.params.send_mail_id) mailData['id'] = parseInt(this.$route.params.send_mail_id)
                let success
                if (this.receive_mail.receive_mail_id) {
                    mailData.mail_id = this.receive_mail.id
                    success = await this.replyMail(mailData)
                    this.isSendInNewTab = true;
                } else {
                    success = await this.createMail(mailData)
                    this.isSendInNewTab = true;
                }
                if (!success) {
                    successAll = false;
                }
                else{
                    successAll = true;
                }
                if (successAll) {
                    this.tabActive = 2;
                    if (this.$route.query.mode == 'sdsk') {
                        this.sendPostMessage('send', true);
                        return;
                    }
                    const listMailSendBulk = await this.getListBroadCast()
                    this.itemTargetOptions = [];
                    if (listMailSendBulk.length) {
                        this.itemTarget = listMailSendBulk[0].id
                    }
                    listMailSendBulk.map(value => {
                        this.itemTargetOptions.push({
                            label: value.subject != null ? `${value.sent_datetime} ${value.subject}` :value.sent_datetime,
                            value: value.id,
                        })
                    })
                    localStorage.setItem('refreshPage' , 'draft');
                    this.mailSubject = '';
                    this.csv_data = null;
                    this.inquiryType = {};
                    this.type = {};
                    this.mst_user = {};
                    this.mailMessage = '';
                    this.showDialogSend = false
                    this.removeCSVFile()
                } else {
                    if (this.$route.query.mode == 'sdsk') {
                        this.sendPostMessage('send', false);
                        return;
                    }
                }
            },
            sendPostMessage(type, result) {
                let data = {
                    type,
                    from: window.location.origin,
                    result
                }
                let targetOrigin = getLS('from');
                window.postMessage(data, targetOrigin)
            },

            //Signature
            onGridReadySignature(params) {
                this.gridApiSignature = params.api;
                this.columnApiSignature = params.columnApi;
            },
            async onSelectionChangedSignature() {
                let selectedSignature = this.gridApiSignature.getSelectedRows()
                let listSignatureSelectId = [];
                selectedSignature.forEach(function (selectedRow, index) {
                    listSignatureSelectId.push(selectedRow.id);
                });
                let signatureSelect = null
                this.listUserSignature.map((element) => {
                    if (listSignatureSelectId[0] == element.id) {
                        signatureSelect = element.signature;
                    }
                })
                this.signatureSelect = signatureSelect
            },

            async applySignature() {
                if (this.modeHTML) {
                    //Get selection pointer cursor
                    var selection = this.$refs.quillMessage.quill.getSelection()
                    //Insert
                    this.signatureSelect = this.signatureSelect.replaceAll(/&lt;/g, '<')
                    this.signatureSelect = this.signatureSelect.replaceAll(/&gt;/g, '>')
                    this.signatureSelect = this.signatureSelect.replaceAll(/&amp;/g, '&')
                    this.$refs.quillMessage.quill.insertText(selection ? selection.index : 0, this.signatureSelect);
                    this.mailMessage = this.mailMessage.replaceAll(/&lt;/g, '<')
                    this.mailMessage = this.mailMessage.replaceAll(/&gt;/g, '>')
                    this.mailMessage = this.mailMessage.replaceAll(/&amp;/g, '&')
                    this.popUpSignature = false
                    setTimeout(() => this.$refs.quillMessage.quill.setSelection(selection ? selection.index : 0), 0)
                } else {
                    var textMessage = document.getElementById('textMessage');
                    let value = textMessage.value
                    let start = textMessage.selectionStart
                    let end = textMessage.selectionEnd
                    textMessage.value = value.slice(0, start) + htmlToFormattedText(this.signatureSelect) + value.slice(end);
                    textMessage.focus();
                    textMessage.selectionEnd = start
                    this.mailMessage = textMessage.value
                    this.popUpSignature = false
                }

            },
            async autoSaveMailDraft() {
                if (this.autosave) {
                    clearTimeout(this.autosave)
                }
                this.autosave = setTimeout(() => {
                    this.onSaveDraft();
                }, 5000)
                localStorage.setItem('saveMailDraft', true)
            },
            async setPreMailDraft() {
                let preMailDraft = this.preMailDraft;
                preMailDraft.forEach(element => {
                    if (element.id == parseInt(this.$route.params.send_mail_id)) {
                        this.inquiryType = {
                            label: element.inquiry_type_text,
                            value: element.inquiry_type
                        };
                        this.type = {
                            label: element.kinds_name,
                            value: element.kinds_state
                        };
                        this.mst_user = {
                            label: element.mst_user,
                            value: element.mst_user_id
                        };
                        this.listMailTo = (element.to && element.to.length > 0) ? element.to.split(",") : [];
                        this.listMailCC = (element.cc && element.cc.length > 0) ? element.cc.split(",") : [];
                        this.listMailBCC = (element.bcc && element.bcc.length > 0) ? element.bcc.split(",") : [];
                        let listFileAttachment = (element.attachment_filepath && element.attachment_filepath.length > 0) ? element.attachment_filepath.split(",") : [];
                        this.files = [];
                        listFileAttachment.forEach((file) => {
                            this.files.push({file_name: file})
                        });
                        this.mailSubject = element.subject;
                        this.modeHTML = element.body_type ? false : true;
                        setTimeout(() => this.mailMessage = element.body, 0);
                        return;
                    }
                })
            },
            async setModeHTML(mailSent) {
                if (mailSent.body_type) {
                    this.modeHTML = mailSent.body_type == 0;
                } else {
                    this.modeHTML = true;
                }
            },
            changeMessage() {
                if (!this.modeHTML) {
                    this.mailMessage = this.mailMessage.split('<br>')
                    this.mailMessage = this.mailMessage.join("")
                    this.mailMessage = htmlToFormattedText(this.mailMessage)
                    this.mailMessage = Html5Entities.decode(this.mailMessage)
                } else {
                    this.mailMessage = Html5Entities.encode(this.mailMessage)
                    this.mailMessage = this.mailMessage.split('\n')
                    this.mailMessage = this.mailMessage.join('\n<br/>')
                    this.mailMessage = this.mailMessage.split(' ')
                    this.mailMessage = this.mailMessage.join('&nbsp;')
                }
            },
            async convertDateTime(dateTime) {
                const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"];
                let date = new Date(dateTime);
                let AmorPM = date.getHours() < 12 ? ' AM' : ' PM';
                let hour = date.getHours();
                if (hour > 12) hour -= 12;
                let time = hour + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + AmorPM;
                let dateTimeFormatted = dayNames[date.getDay()] + ', ' + monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear() + ' ' + time;
                return dateTimeFormatted;
            },
            displayStatusSendMail(state_flg) {
                switch (state_flg) {
                    case 0:
                        return '削除'
                        break;
                    case 1:
                        return '送信済み'
                        break;
                    case 2:
                        return '送信失敗'
                        break;
                }
            },
            displayStatusReadMail(is_read) {
                switch (is_read) {
                    case 0:
                        return '未開封'
                        break;
                    case 1:
                        return '開封済み'
                        break;
                }
            },
            displayCountSendMailSuccess() {
                return this.sendMailsCoppy.filter(item => item.state_flg == 1).length
            },
            displayCountSendMailIsRead() {
                return this.sendMailsCoppy.filter(item => item.is_read == 1).length
            },
            displayRateSendMailIsRead() {
                if (this.sendMailsCoppy.length === 0) return 0
                return (this.displayCountSendMailIsRead()) / this.sendMailsCoppy.length * 100;
            },
            async onExportCSV() {
                //Create data CSV
                const data =  await this.exportMailSendToCSV(this.itemTarget);
                const dataExport = data.map(item => {
                        return {
                            id: item.id,
                            to: item.to,
                            status_send: this.displayStatusSendMail(item.state_flg),
                            status_read: this.displayStatusReadMail(item.is_read),
                        }
                    })
                if (dataExport.length > 0) {
                    this.$refs.exportCSV.jsonData = dataExport
                    this.$refs.exportCSV.handleClick();
                }
            },
            showListContact(type) {
                this.$nextTick(() => {
                    this.activeModelContacts = true
                    this.typeModalContact = type;
                });
            },
            removeDuplicates(array) {
                return array.filter((item, index) => array.indexOf(item) === index);
            },
            contactSelected(contact,typeContact) {
                if (typeContact === 'TO') {
                    this.listMailTo = this.removeDuplicates([...this.listMailTo, contact]);
                } else if (typeContact === 'CC') {
                    this.listMailCC = this.removeDuplicates([...this.listMailCC, contact]);
                } else if (typeContact === 'BCC') {
                    this.listMailBCC = this.removeDuplicates([...this.listMailBCC, contact]);
                }
            },
            styleContactListDropdown(contactsDropdownId, vschipsId){
                //Start process contacts dropdown
                let concChipsTo = document.querySelector('#'+vschipsId+'>.con-chips')
                concChipsTo.style.paddingRight = '45px';
                let contactsDropdown = document.getElementById(contactsDropdownId)
                contactsDropdown.style.display = 'none';
                setTimeout(() => {
                    contactsDropdown.style.maxHeight = '114px'
                    contactsDropdown.style.overflowY = 'scroll'
                }, 20)
                let conChipsInputTo = document.querySelector('#'+vschipsId+'>.con-chips>.con-chips--input')
                conChipsInputTo.addEventListener('input', function() {
                    let search = conChipsInputTo.value.toLowerCase();
                    if(search != '') {
                    contactsDropdown.style.display = 'block';
                    } else {
                    contactsDropdown.style.display = 'none';
                    }
                    let lists = document.querySelectorAll('#'+contactsDropdownId+'>li');
                    const listsLen = lists.length;
                    let totalContactsShow = 0
                    for (let i = 0; i < listsLen; ++i) {
                    const listContent = lists[i].textContent.toLowerCase();
                    if (listContent.indexOf(search) > -1) {
                        lists[i].style.display = 'block';
                        totalContactsShow++
                    } else {
                        lists[i].style.display = 'none';
                    }
                    }
                    if(!totalContactsShow) {
                    contactsDropdown.style.display = 'none';
                    }
                })

                document.addEventListener('click', function handleClickOutsideBox(event) {
                    if (!contactsDropdown.contains(event.target)) {
                    contactsDropdown.style.display = 'none';
                    conChipsInputTo.value = '';
                    }
                });
                
                contactsDropdown.addEventListener('click', () => {
                    contactsDropdown.style.display = 'none';
                    conChipsInputTo.value = '';
                    conChipsInputTo.focus();
                });
                //End process contacts dropdown
            },
        },
        async created() {
            let mailBoxParams = this.$route.params.email;
            if(this.$route.meta.isShowIConContact) {
                this.showIconContacts = true
            }
            await this.fetchContactList()
            /* start loading with many requests */
            this.$store.dispatch('updateLoads', true)
            this.isRead = await this.setUserReadOnly(mailBoxParams) > 0;

            await this.getUserSignature();
            this.isReport = true
            this.listMailTo = []
            const mailBox = await this.getListMailBoxSend()
            const listMailSendBulk = await this.getListBroadCast()
            if (listMailSendBulk.length) {
              this.itemTarget = listMailSendBulk[0].id
            }
            listMailSendBulk.map(value => {
              this.itemTargetOptions.push({
                label: value.subject != null ? `${value.sent_datetime} ${value.subject}` :value.sent_datetime,
                value: value.id,
              })
            })
            await this.getListKindsSelect()
            await this.getListMstUserSelect()
            mailBox.filter(item => {
              this.listMailFrom.push(item.sent_user_name)
            })

            this.mailFrom = ''
            if (this.$route.params.email) {
                let emailFrom = this.$route.params.email
                this.mailFrom = this.listMailFrom.find(mail => mail === emailFrom)
            }
            this.mailSubject = ''
            let lineBreak = this.modeHTML ? '<br>' : '\n';
            this.mailMessage = ''
            this.mailMessage = lineBreak + this.mailMessage
            document.getElementById('quillMessage').focus()
            this.files = []
            this.listInquiryTypeSelect = [
                {value: 0, label: 'メール'},
                {value: 1, label: '電話'},
                {value: 2, label: '営業'},
                {value: 9, label: 'その他'}
            ],
            this.countReplyMail = 1
            // PAC_21-136
            this.type = this.type && this.listTypeSelect[1];
            let idUser = this.$store.state.AppActiveUser.id;
            this.mst_user = this.listMstUserSelect.find(item => item.value == idUser)
            // END PAC_21-136

            this.isCreated = true;
            //Get list mail template
            await this.getListMailTemplate({
                user_id: this.$store.state.AppActiveUser.id,
            });

            //Get list settings
            await this.getListSettingsSelect();

            /* stop loads */
            this.$store.dispatch('updateLoads', false)
        },
        beforeDestroy() {
            // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
            document.getElementById('dialogSend').style.display = 'none'
            if (this.isReport) window.removeEventListener('popstate', this.onBack);
        },
        beforeUpdate() {

        }
    };
</script>


<style lang="scss">
    @import "@/assets/scss/vuexy/components/view/sendMail.scss";

    #page-send-mail {
        .container-wrap {
            position: relative;
        }
        .ql-editor {
            min-height: 100px !important;
        }
        .btn-groups {
            position: absolute;
            left: 10px;
        }

        .tab-history {
            border: 1px solid #42719B;
            padding: 0 31px !important;
            min-width: 92px;
            width: 92px;
            max-height: 40px;
            height: 40px;
        }

        .tab-send-mail {
            border: 1px solid #42719B;
            padding: 0 31px !important;
        }
        .tab-active {
            background-color: #0F86F5 !important;
        }

        .text-not-active {
            color: black !important;
        }

        .table-history th, tr, td {
            /*border: 1px solid black;*/
            text-align: center;
        }

        .table-history .vs-table--tbody {
            border: 1px solid lightgrey;
            border-radius: 5px;
        }

        .table-history th {
            background-color: #F8CBAD;
        }

        .vs-table-text {
            display: flex;
            justify-content: center;
        }

        .select-history {
            width: 100%;
        }

        .select-history .v-select {
            border: 1px solid #cdcdcd !important;
            /*width: 40% !important;*/
        }

        .output-csv {
            display: flex;
        }

        .vs__dropdown-toggle {
            .vs__selected-options {
                .vs__search {
                    position: absolute;
                    z-index: -1;
                }
            }
        }

        .vs-switch-primary {
            height: 40px !important;

            .vs-switch--text {
                font-size: 1rem;
            }

            .vs-switch--circle {
                height: 24px !important;
                width: 24px !important;
                border-radius: 12px !important;
                top: 7px !important;
                left: 2px !important;
            }
        }

        .vs-switch-active .vs-switch--circle {
            margin-left: calc(100% - 29px) !important;
        }
        .card-file-input {
            .table-add-one-colum table {
                width: auto;
            }
        }
    }
    .select-history {
        .text-not-active {
            color: black;
        }
        .tab-send-mail-tab-2 {
            border: 1px solid #42719B;
            padding: 9px 31px !important;
            min-width: 92px;
            width: 92px;
            max-height: 39px;
            height: 39px;
            margin-right: 2px;
        }
        .tab-active-tab-2 {
            background-color: #0F86F5 !important;
            min-width: 92px;
            width: 92px;
            max-height: 40px;
            height: 40px;
            border: 1px solid #42719B;
        }
        .select-broadcast {
            margin-left: 9px;
            .vs__selected-options {
                flex-wrap: nowrap;
                max-width: calc(100% - 25px);
            }
            .vs__selected {
                display: block;
                white-space: nowrap;
                text-overflow: ellipsis;
                max-width: 100%;
                overflow: hidden;
            }
            .vs__dropdown-toggle {
                height: 41px;
                display: flex;
                align-items: center;
            }
        }
    }

    .mail-template-list-dropdown {
        .vs-dropdown--menu {
            right: -250px;
            width: 300px;
            padding: 0 !important;

            .vs-divider {
                margin: 10px 0 0 0;
            }

            h5 {
                margin: 10px 0 0 5px;
            }

            .mail-template-list {
                height: 150px;
                overflow: scroll;

                .template-item {
                    width: 100%;
                    padding: 10px 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .vs-dropdown--item-link {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0;
                    }

                    .vs-icon {
                        &:hover {
                            cursor: pointer;
                        }
                    }

                    &:hover {
                        background-color: rgb(187, 187, 187);
                    }

                    &:nth-child(even):not(h5) {
                        background-color: lightgrey;

                        &:hover {
                            background-color: rgb(187, 187, 187);
                        }
                    }
                }
            }
        }

        .vs-dropdown--menu--after {
            background-color: transparent !important;
        }
    }

    .vs-popup {
        .vs-popup--content {
            .vs-input-primary {
                width: 100%;
            }
        }
    }

    .csv-content {
        max-height: 250px;
        overflow: auto;
    }
    .paginate .vs-pagination--mb:first-child {
        display: none !important;
    }
    .paginate .vs-pagination--mb {
       width: 100% !important;
        justify-content: center !important;
    }
    .vschipsContacts .con-chips .con-chips--remove-all {
        display: none;
    }
    .contact-li {
        font-size: 15px; 
        padding: 3px 10px;
        &:hover {
            background-color: #5897fb;
        }
    }
</style>